// @ts-nocheck
import { Enumeration } from "./Enumeration";
import { application } from "./WebApp.Instance";

export const ConfirmationClass = new Enumeration(["Confirm", "Delete"]);

export class ConfirmationWindowComponent {
  constructor(message, confirmLabel, cancelLabel, handler, class_ = ConfirmationClass.Confirm, target = null) {
    this.message = message;
    this.confirmLabel = confirmLabel;
    this.cancelLabel = cancelLabel;
    this.handler = handler;
    this.class = class_;
    this.target = target;
  }

  show() {
    if (!this.element) {
      this.element = document.createElement("div");
      this.element.classList.add(ConfirmationClass.toText(this.class));
      this.element.classList.add("ConfirmationWindowComponent");
      this.element.tabIndex = "-1";

      const window = document.createElement("div");
      window.classList.add("ConfirmationWindow");

      const message = document.createElement("span");
      message.classList.add("Message");
      message.append(this.message);

      const confirm = document.createElement("button");
      confirm.type = "button";
      confirm.classList.add("Confirm");
      confirm.append(this.confirmLabel);

      const cancel = document.createElement("button");
      cancel.type = "button";
      cancel.classList.add("Cancel");
      cancel.append(this.cancelLabel);

      window.appendChild(message);
      window.appendChild(confirm);
      window.appendChild(cancel);

      this.element.appendChild(window);

      confirm.addEventListener(
        "click",
        (event) => {
          this.confirm();

          event.stopPropagation();
          event.preventDefault();
        }
      );

      cancel.addEventListener(
        "click",
        (event) => {
          this.cancel();

          event.stopPropagation();
          event.preventDefault();
        }
      );

      this.element.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "Enter") {
            this.confirm();

            event.stopPropagation();
            event.preventDefault();
          }
          else if (event.key === "Escape") {
            this.cancel();

            event.stopPropagation();
            event.preventDefault();
          }
        }
      );

      if (this.target !== null)
        this.target.appendChild(this.element);
      else
        application.pageHandler.contents.element.appendChild(this.element);

      this.element.focus();
    }
  }

  cancel() {
    this.hide();
  }

  confirm() {
    this.handler();
    this.hide();
  }

  hide() {
    if (this.element) {
      this.element.remove();
      this.element = undefined;
    }
  }
}
